import React from 'react';
import { recoveryGoalSettingReport } from '../../resources/commonStrings';
import reportDetails from '../Navigation/reportDetails';
import Settings from '../../resources/settings';
import styles from './ReportGenerationErrorBanner.module.css';

function ReportGenerationErrorBanner({ numberProp, stringProp }) {
  return (
    <div data-testid={'error-banner'} className={styles['banner']}>
      <div className={styles['flag']} />
      <div className={`${styles['message']} nwea-ds-v1-typography-body-copy-medium`}>
        <span className={styles['banner-intro']}>{recoveryGoalSettingReport.errorBanner.errorMsgBold}</span>{' '}
        {recoveryGoalSettingReport.errorBanner.errorMsgNormal}
        {recoveryGoalSettingReport.errorBanner.linkIntro}
        <a
          data-testid="banner-link"
          className={styles['banner-link']}
          href={`${Settings.URL_BASE_PATH}${reportDetails.recoveryGoalSetting.urlEndPoint}`}
          target="_blank"
        >
          {recoveryGoalSettingReport.errorBanner.linkText}
        </a>
        {recoveryGoalSettingReport.errorBanner.linkOutro}
      </div>
    </div>
  );
}

export default ReportGenerationErrorBanner;
